import { z } from "zod";
export const breakdownTypes = [
    "flat_battery",
    "engine_failure",
    "puncture",
    "locked_out",
    "accident",
    "other",
];
export const vehicleLocations = [
    "roadside",
    "hard_shoulder",
    "car_park",
    "home",
    "other",
];
export const tollOptions = [
    "toll_road",
    "dartford",
    "ulez",
    "congestion",
    "mersey",
    "tyne",
];
export const rescueSchema = z.object({
    breakdownType: z.enum(breakdownTypes, { message: "Select breakdown type" }),
    isDriveable: z.boolean().optional(),
    vehicleLocation: z.enum(vehicleLocations, { message: "Select location" }),
    blockingTraffic: z.boolean().optional(),
    deliveryAddress: z.string().min(1, "Tow destination is required"),
    tolls: z.array(z.enum(tollOptions)).optional(),
    photos: z.array(z.string()).max(3, "Max 3 photos").optional(),
    notes: z.string().max(500).optional(),
    isNight: z.boolean().optional(),
    isHoliday: z.boolean().optional(),
});
//# sourceMappingURL=schema.js.map